import { useContext } from 'react';
import AuthContext, { AuthContextType } from './AuthContext';

const useAuth = (): AuthContextType => useContext(AuthContext);
export default useAuth;
